/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by Omnia
 * On: 13/Oct/2026.
 */
@file:kotlin.js.JsExport

package com.narbase.letsgo.web.routing.domain.admin.ridepromocodes

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.ridepromocode.ExtendedRidePromoCodeDto

object GetRidePromoCodesEndpoint : EndPoint<GetRidePromoCodesEndpoint.Request, GetRidePromoCodesEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
        val onlyActiveAutoAssign: Boolean?,
    )

    class Response(
        val list: Array<ExtendedRidePromoCodeDto>,
        val total: Int,
    )
}